import { useTranslation } from "react-i18next";
import { CustomButton } from "../../components";
import "./styles.scss";

const SessionExpiredPopup = ({ show, onClickConfirm }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <div className="session-expired-popup-container">
      <div className="session-expired-popup-content">
        <h1 className="heading">
          {t("company-details.session_expired_heading")}
        </h1>
        <p className="description">
          {t("company-details.session_expired_description")}
        </p>
        <div className="custom-button-wrapper">
          <CustomButton
            text={t("company-details.start_again")}
            onClick={onClickConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredPopup;
